import { render } from "./instructor-quiz-details.vue?vue&type=template&id=0d9651e3"
import script from "./instructor-quiz-details.vue?vue&type=script&lang=js"
export * from "./instructor-quiz-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__